/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsOsvVulnerabilityFixDetails {
    getFixupPrototypeFunction() { return AppSecopsOsvVulnerabilityFixDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsOsvVulnerabilityFixDetails>): AppSecopsOsvVulnerabilityFixDetails {
        let obj = Object.assign(new AppSecopsOsvVulnerabilityFixDetails(), model);
        AppSecopsOsvVulnerabilityFixDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsOsvVulnerabilityFixDetails>): AppSecopsOsvVulnerabilityFixDetails {
        if (!model) return null;
        return AppSecopsOsvVulnerabilityFixDetails.newInstance(<AppSecopsOsvVulnerabilityFixDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsOsvVulnerabilityFixDetails) {
        if (!obj) return;

        models.AppSecopsOsvVulnerabilityFixDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsOsvVulnerabilityFixDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsOsvVulnerabilityFixDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Version that fixed the vulnerability
     */
    fixed: string;

    /**
     * Version that introduced the vulnerability
     */
    introduced: string;

    /**
     * Version that last affected the vulnerability
     */
    last_affected: string;

    /**
     * Limit the vulnerability
     */
    limit: string;

}
